module.exports = __webpack_public_path__ + "img/syukyaku-EC-mo-001.97981792.jpg";